import videoPlayer from './play-video';

const eventStates = {
  loading: 'loading',
  playbackReady: 'ready',
  'Authorisation required': 'ready'
};

const setVideoState = (rootElement, state) => {
  const videoToggles = rootElement.querySelectorAll('[data-role="video-toggle"]');
  const currentState = state in eventStates ? eventStates[state] : 'ready';
  videoToggles.forEach(t => t.setAttribute('data-playing', currentState));
};

export default function(rootElement) {
  const videoContent = rootElement.querySelector('[data-role="header-video-content"]');

  if (videoContent) {
    /* eslint-disable no-console */
    videoPlayer.getPlayer(videoContent)
      .then(player => {
        if (typeof player.getState !== 'function') {
          setVideoState(rootElement, 'ready');
          return;
        }
        setVideoState(rootElement, player.getState());
        player.mb.subscribe('*', 'sdc-site-match-header-highlight-video', (event) => {
          if (event in eventStates) {
            setVideoState(rootElement, event);
          }
        });
      })
      .catch(err => {
        console.log(err);
        setVideoState(rootElement, err);
      });
    /* eslint-enable */
    const toggles = videoContent.querySelectorAll('[data-role="video-toggle"]');

    toggles.forEach(toggle => {
      toggle.addEventListener(
        'click',
        () => {
          if ('playing' in toggle.dataset && toggle.dataset.playing === 'ready') {
            if (videoContent.hasAttribute('expanded')) {
              videoContent.removeAttribute('expanded');
              videoPlayer.stopVideo(videoContent);
            } else {
              videoContent.setAttribute('expanded', '');
              videoPlayer.playVideo(videoContent);
            }
          }
        },
        false
      );
    });
  }
}
